import {IconButton, Stack, TableCell, TableRow, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Delete02Icon, PencilEdit01Icon} from "@hugeicons/core-free-icons";
import moment from "moment";
import {CampaignStatusChips} from "./CampaignStatusChips";
import {extensionLabel} from "../hooks/useAmiExtensions";

const cellSx = {fontSize: 12, color: "text.secondary", whiteSpace: "nowrap"};

// Stops the row click (open campaign) from firing
const stop = (handler) => (e) => {
  e.stopPropagation();
  handler();
};

export const CampaignRow = ({campaign, extension, onOpen, onEdit, onDelete}) => {
  return (
    <TableRow hover sx={{cursor: "pointer"}} onClick={() => onOpen(campaign)}>
      <TableCell>
        <Typography fontWeight={600} fontSize={13}>{campaign.name}</Typography>
        {campaign.description &&
          <Typography fontSize={11} color="text.secondary" noWrap sx={{maxWidth: 240}}>
            {campaign.description}
          </Typography>
        }
      </TableCell>
      <TableCell sx={cellSx}>{campaign.fromNumber || "-"}</TableCell>
      <TableCell sx={cellSx}>{extensionLabel(extension) || (campaign.extensionId ? "Unknown" : "-")}</TableCell>
      <TableCell sx={cellSx}>
        {moment(campaign.startDate).format("DD MMM YYYY")} – {moment(campaign.endDate).format("DD MMM YYYY")}
      </TableCell>
      <TableCell sx={cellSx}>{campaign.startTime} – {campaign.endTime}</TableCell>
      <TableCell sx={cellSx}>{campaign.maxAttempts}</TableCell>
      <TableCell sx={cellSx}>{campaign.totalPhoneNumbers ?? 0}</TableCell>
      <TableCell sx={{minWidth: 200, "& .MuiChip-root": {height: 20, fontSize: 10, borderRadius: 1.5}, "& .MuiChip-label": {px: 0.75}}}>
        <CampaignStatusChips statusCounts={campaign.statusCounts} statuses={["ANSWERED", "FAILED"]} neutral/>
      </TableCell>
      <TableCell sx={cellSx}>
        {campaign.dateCreated ? moment(campaign.dateCreated).format("DD MMM YYYY HH:mm") : "-"}
      </TableCell>
      <TableCell padding={"checkbox"}>
        <Stack direction="row">
          <Tooltip title="Edit">
            <IconButton size="small" aria-label={`Edit ${campaign.name}`} onClick={stop(() => onEdit(campaign))}>
              <HugeiconsIcon icon={PencilEdit01Icon} size={16}/>
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton size="small" color="error" aria-label={`Delete ${campaign.name}`} onClick={stop(() => onDelete(campaign))}>
              <HugeiconsIcon icon={Delete02Icon} size={16}/>
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>
    </TableRow>
  )
}
